import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { getConfig } from '@cian/config/browser';
import { TReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';
import { ICustomContextParams } from '../../../shared/types/ICustomContextParams';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

interface IDependencies {
  store: TReduxStore;
  httpApi: IHttpApi;
  logger: ILogger;
}

export function renderApplication(dependencies: IDependencies) {
  const config = getConfig();
  const { store, httpApi, logger } = dependencies;

  const projectName = config.getStrict<string>('projectName');
  const customContext = config.getStrict<ICustomContextParams>('applicationContext.custom');
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  ReactDOM.hydrate(
    <Application httpApi={httpApi} config={config} logger={logger} reduxStore={store} customContext={customContext} />,
    rootElement,
  );
}
